import { useState } from 'react'

const useOpenOopsPopup = () => {
    const [isModelOpen, setIsModelOpen] = useState(false);
    const handlePopUpOpen = () => setIsModelOpen(true);
    const handlePopUpClose = () => setIsModelOpen(false);
    return { isModelOpen, handlePopUpOpen, handlePopUpClose }
}

export default useOpenOopsPopup